import styled from 'styled-components';

export const HttpsText = styled.p`
  font-size: 16px;
  color: ${props => props.theme.interface5};
  margin: 10px 0;
  margin-bottom: 24px;
`;
